const accomplishmentsGrid =
  "w-full grid grid-cols-4 gap-5 mb-5 place-items-center justify-items-start";

export default accomplishmentsGrid;
